require('./modules/is-IE');

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.App = {}
var App = window.App;

// import { TweenMax, TimelineMax, TweenLite, TimelineLite, Expo, Quart } from 'gsap';
// import ScrollMagic from 'scrollmagic';
// window.TweenMax = TweenMax;
// window.TimelineMax = TimelineMax;
// window.TweenLite = TweenLite;
// window.TimelineLite = TimelineLite;
// window.Expo = Expo;
// window.Quart = Quart;
// window.ScrollMagic = ScrollMagic;
// import 'imports-loader?define=>false!./plugins/animation.gsap';
// import 'imports-loader?define=>false!./plugins/debug.addIndicators';

var Bootstrap 	= require('./bootstrap'); // Responsive
var jValidate 	= require('./plugins/jquery.validate.min.js'); // Form validation
// require('./plugins/messages_fr.min'); // Form validation
var Modernizr 	= require('./plugins/modernizr');
var Barba 			= require('./plugins/barba');
var Animations 	= require('./modules/animations.js');

import SmoothScroll from 'smooth-scrollbar';
import Swiper 			from 'swiper/dist/js/swiper.js';
import lozad 				from 'lozad';
import Player 			from '@vimeo/player';

// FR jQuery validate
!function(a){"function"==typeof define&&define.amd?define(["jquery","../jquery.validate.min"],a):"object"==typeof module&&module.exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){return a.extend(a.validator.messages,{required:"Ce champ est obligatoire.",remote:"Veuillez corriger ce champ.",email:"Veuillez fournir une adresse électronique valide.",url:"Veuillez fournir une adresse URL valide.",date:"Veuillez fournir une date valide.",dateISO:"Veuillez fournir une date valide (ISO).",number:"Veuillez fournir un numéro valide.",digits:"Veuillez fournir seulement des chiffres.",creditcard:"Veuillez fournir un numéro de carte de crédit valide.",equalTo:"Veuillez fournir encore la même valeur.",notEqualTo:"Veuillez fournir une valeur différente, les valeurs ne doivent pas être identiques.",extension:"Veuillez fournir une valeur avec une extension valide.",maxlength:a.validator.format("Veuillez fournir au plus {0} caractères."),minlength:a.validator.format("Veuillez fournir au moins {0} caractères."),rangelength:a.validator.format("Veuillez fournir une valeur qui contient entre {0} et {1} caractères."),range:a.validator.format("Veuillez fournir une valeur entre {0} et {1}."),max:a.validator.format("Veuillez fournir une valeur inférieure ou égale à {0}."),min:a.validator.format("Veuillez fournir une valeur supérieure ou égale à {0}."),step:a.validator.format("Veuillez fournir une valeur multiple de {0}."),maxWords:a.validator.format("Veuillez fournir au plus {0} mots."),minWords:a.validator.format("Veuillez fournir au moins {0} mots."),rangeWords:a.validator.format("Veuillez fournir entre {0} et {1} mots."),letterswithbasicpunc:"Veuillez fournir seulement des lettres et des signes de ponctuation.",alphanumeric:"Veuillez fournir seulement des lettres, nombres, espaces et soulignages.",lettersonly:"Veuillez fournir seulement des lettres.",nowhitespace:"Veuillez ne pas inscrire d'espaces blancs.",ziprange:"Veuillez fournir un code postal entre 902xx-xxxx et 905-xx-xxxx.",integer:"Veuillez fournir un nombre non décimal qui est positif ou négatif.",vinUS:"Veuillez fournir un numéro d'identification du véhicule (VIN).",dateITA:"Veuillez fournir une date valide.",time:"Veuillez fournir une heure valide entre 00:00 et 23:59.",phoneUS:"Veuillez fournir un numéro de téléphone valide.",phoneUK:"Veuillez fournir un numéro de téléphone valide.",mobileUK:"Veuillez fournir un numéro de téléphone mobile valide.",strippedminlength:a.validator.format("Veuillez fournir au moins {0} caractères."),email2:"Veuillez fournir une adresse électronique valide.",url2:"Veuillez fournir une adresse URL valide.",creditcardtypes:"Veuillez fournir un numéro de carte de crédit valide.",ipv4:"Veuillez fournir une adresse IP v4 valide.",ipv6:"Veuillez fournir une adresse IP v6 valide.",require_from_group:a.validator.format("Veuillez fournir au moins {0} de ces champs."),nifES:"Veuillez fournir un numéro NIF valide.",nieES:"Veuillez fournir un numéro NIE valide.",cifES:"Veuillez fournir un numéro CIF valide.",postalCodeCA:"Veuillez fournir un code postal valide."}),a});


//--------------
// Variables
//--------------
App.mode = document.querySelector('body').getAttribute('data-mode');
window.animationsController = null;

window.Swiper 			= Swiper;
window.Player 			= Player;
window.Barba 				= Barba;
window.Animations 	= Animations; 
window.SmoothScroll = SmoothScroll;
window.Scrollbar 		= null;

window.Observer = lozad('.lazy', {
	loaded: function(el) {
  	el.onload = function() {
    	el.classList.add('is-loaded');

    	setTimeout(function(){
    		el.classList.remove('lazy');
    		el.classList.remove('is-loaded');
    	}, 1500);
  	}
  }
});

window.dataLayer = window.dataLayer || [];
window.gtag = function(){
	dataLayer.push(arguments);
}

//--------------
// Functions
//--------------

/**
 * Init all scripts
 * @return {void}
 */
App.init = function(){
	/* ----------------------
	/* GLOBAL
	/---------------------- */

	// Add loaded class on body
	$('body').addClass('main-loaded');

	/* ----------------------
	/* COMMON
	/---------------------- */
	require('./pages/common.js').init();

	/* ----------------------
	/* HEADER
	/---------------------- */
	var $header = $('[data-module="header"]');
	if ($header.length > 0) {
	  var Header = require('./modules/header.js');
	}

	/* ----------------------
	/* HOME
	/---------------------- */
	var $home = $('[data-module="home"]');
	if ($home.length > 0) {
		var homeBanner = document.querySelector('.js-home-banner-image')
		Observer.triggerLoad(homeBanner);
	  require('./pages/home.js').init();
	}

	/* ----------------------
	/* PROJECTS CAROUSEL
	/---------------------- */
	var $projectsCarousel = $('[data-module="projects-carousel"]');
	if ($projectsCarousel.length > 0) {
	  require('./modules/projects-carousel.js').init();
	}

	/* ----------------------
	/* CONTACT
	/---------------------- */
	var $contact = $('[data-module="contact"]');
	$('.js-contact-button').fadeOut();
	
	if ($contact.length > 0) {
	  require('./pages/contact.js').init();
	} else {
		App.isContactButton = false;
		Scrollbar.addListener(function(){
			var scrollTop = Scrollbar.offset.y;

			if(scrollTop > 500 && !App.isContactButton) {
				$('.js-contact-button').fadeIn(800);

				App.isContactButton = true;
			}

			if(scrollTop < 500 && App.isContactButton) {
				$('.js-contact-button').fadeOut(800);

				App.isContactButton = false;
			}
		});
	}

	/* ----------------------
	/* BLOG
	/---------------------- */
	var $blog = $('[data-module="blog"]');
	if ($blog.length > 0) {
	  require('./pages/blog.js').init();
	}

	/* ----------------------
	/* SERVICE BANNER
	/---------------------- */
	var $serviceBanner = $('[data-module="service-banner"]');
	if ($serviceBanner.length > 0) {
	  require('./modules/service-banner.js').init();
	}

	/* ----------------------
	/* SOCIAL SHARE
	/---------------------- */
	var $socialShare = $('[data-module="social-share"]');
	if ($socialShare.length > 0) {
	  require('./modules/social-share.js').init();
	}

	/* ----------------------
	/* COOKIES
	/---------------------- */
	require('./modules/cookies.js');

	/* ----------------------
	/* DARK MODE
	/---------------------- */
	require('./modules/dark-mode.js').init();

	/* ----------------------
	/* CHRISTMAS
	/---------------------- */
	var $christmas = $('[data-module="christmas"]');
	$('canvas.background').remove();
	$('.js-christmas-popup').fadeOut();
	if ($christmas.length > 0) {
	  require('./specials/christmas.js').init();
	}


	/**
	 * Init Barba
	 */
	Barba.destroy();
	Barba.init({
		timeout: 5000,
		schema: {
	    prefix: 'data-anim'
	  },
	  transitions: [
	  	// Global transition
	  	{
	  		name: 'Global transitions',
				custom: ({ current, next, trigger }) =>
	        	trigger.classList && trigger.classList.contains('js-link') || 
	        	trigger.classList && trigger.classList.contains('js-menu-col') ||
	        	trigger === 'popstate',
		    leave({current, next, trigger}) {
		    	console.log('LEAVE CURRENT', current);
		    	console.log('LEAVE NEXT', next);

		    	return new Promise(resolve => {
		    		$(current.container).fadeOut(function(){
		    			$(current.container).remove();
		    		});

		    		Header.closeMenu();
		    		
		        setTimeout(() => {
		        	resolve();
		        }, 500);
		      });
		    },
		    enter({current, next, trigger}) {
		    	console.log('ENTER CURRENT', current);
		    	console.log('ENTER NEXT', next);

		    	$(next.container).hide();
		    	
		    	return new Promise(resolve => {
		    		$(next.container).fadeIn();
		    		App.init();
		    		App.activeServiceBanner(current.url.href, next.url.href);
		      });
		    }
		  }
		]
	});
}

/**
 * [activeServiceBanner description]
 * @param  {[type]} currentUrl [description]
 * @param  {[type]} nextUrl    [description]
 * @param  {[type]} popState   [description]
 * @return {[type]}            [description]
 */
App.activeServiceBanner = function(currentUrl, nextUrl, popState){
	// Si currentUrl ne contient pas service
	// Et si nextUrl contient service
	if( (currentUrl.indexOf('services') < 0 && nextUrl.indexOf('services') > -1) || popState){
		$('.js-service-banner').addClass('is-loaded');
	}
}

//--------------
// Execution
//--------------

App.init();